module.exports = __webpack_public_path__ + "img/music.7e57fc67.png";